import { ProductsMainContainer } from '@/modules/Products';

const ProductsList = (): JSX.Element => <ProductsMainContainer />;

export default ProductsList;
